import { useState } from "react";
import { useApp } from "../contexts";
import { agreePolicy } from "../services/app";
import environment from "../environment";

export default function useAffiliate() {
  const { user, reloadProfile } = useApp();
  const [isOpenModalPolicy, setIsOpenModalPolicy] = useState(false);

  const onAffiliate = () => {
    if (Number(user?.is_agree_policy) === 0) {
      setIsOpenModalPolicy(true);
    } else {
      redirectToMlm();
    }
  };


  const onConfirmPolicy = () => {
    agreePolicy().then((res) => {
      setIsOpenModalPolicy(false);
      reloadProfile();
      redirectToMlm();
    });
  };

  const redirectToMlm = () => {
    const urlMlmRegistration = getMlmRegistrationUrl();
    if (user.evf_affid) {
      window.open(environment.MLM_LOGIN_URL);
    } else {
      window.open(urlMlmRegistration);
    }
  };

  const getMlmRegistrationUrl = () => {
    try {
      const urlMlmRegistration = new URL(environment.MLM_REGISTRATION_URL);
      if (user.email) {
        urlMlmRegistration.searchParams.append("email", user.email);
      }
      return urlMlmRegistration;
    } catch (error) {
      console.error(error);
      return environment.MLM_REGISTRATION_URL;
    }
  };
  return {
    onAffiliate,
    onConfirmPolicy,
    isOpenModalPolicy,
    setIsOpenModalPolicy
  };
}
